import NumberHelper from './../../Shared/Helpers/numberHelper';
import HtmlElementHelper from '../../Shared/Helpers/htmlElementHelper';
import MoneyTransferAmountHelper from '../Shared/Helpers/moneyTransferAmountHelper';
import '../Shared/Extensions/StringExtension';
import '../Shared/Components/transfersummary.component';
import * as Decimal from "decimal.js";

var senderAmountWithoutRoundDefault = window.banking.senderAmountWithoutRoundDefault;
var exchangeRate = window.banking.exchangeRate;
var transferFee = window.banking.transferFee || 0;

// AB#1417: single source of truth for the Venezuela (VES) receiver cap. Business rule:
// receiving more than 50,000 VES is not allowed. Used for BOTH enforcement and display so
// they can never diverge (previously the literal 50000 was repeated in 4 places).
var VES_MAX_RECEIVER = 50000;

jQuery("#senderAmount, #receiverAmount").on({
    "keyup": function (e) {
        if (e.which == 9) // TAB key
            return;

        var id = jQuery(this).attr("id");

        if (id == "senderAmount")
            senderAmountKeyupListener();

        if (id == "receiverAmount")
            receiverAmountKeyupListener();
    }
});

jQuery("#senderAmount, #receiverAmount").on({

    "change": function (e) {
        if (e.which == 9) // TAB key
            return;

        var id = jQuery(this).attr("id");

        if (id == "senderAmount")
            senderAmountChangeListener();

        if (id == "receiverAmount")
            receiverAmountChangeListener();
    }
});

window.senderAmountChangeListener = function () {

    var senderCurrency = jQuery("#senderCurrency").val();
    var senderAmount = MoneyTransferAmountHelper.roundSenderAmount(senderAmountElement.val(), senderCurrency);

    // update senderAmountElement
    senderAmountElement.val(senderAmount);

    window.updateReceivableAmount(senderAmount);
}

window.receiverAmountChangeListener = function () {

    var receiverCurrency = jQuery("#receiverCurrency").val();
    var receiverAmount = MoneyTransferAmountHelper.roundReceiverAmount(receiverAmountElement.val(), receiverCurrency);

    // update receiverAmountElement
    receiverAmountElement.val(receiverAmount);

    window.updateSentAmount();
}

window.senderAmountKeyupListener = function () {
    var senderAmount = senderAmountElement.val();
    senderAmount = senderAmount ? parseFloat(senderAmount) : 0;

    window.updateReceivableAmount(senderAmount);
}

window.receiverAmountKeyupListener = function () {
    window.updateSentAmount();
}

NumberHelper.disableSignInTypeNumber(document.getElementById("senderAmount"));
NumberHelper.disableSignInTypeNumber(document.getElementById("receiverAmount"));

var senderAmountElement = jQuery('#senderAmount');
var senderAmountExactElement = jQuery('#senderAmountExact');

jQuery(document).ready(function () {

    // needed to unblock UI by return back in the browser
    HtmlElementHelper.g_unBlockUI();

    // removed toLocalCulture because type number does not allow commas
    window.updateReceivableAmountInternal(senderAmountExactElement.val().toFloat());
});

var senderCurrency = "";
var receiverCurrency = "";

var feeAmount = "";
var receiverAmountElement = jQuery('#receiverAmount');
var continueButton = jQuery('#button-continue');
var advice = jQuery('#advice-country-limit-exceeded');
var adviceReceiver = jQuery('#advice-country-limit-exceeded-receiver');
var tooLittleMoneyTxt = jQuery('#advice-too-little-money');

window.updateExchangeRate = function (_exchangeRate, _fee, _senderCurrency, _receiverCurrency, isExhangeRateUpdated) {
    var oldExchangeRate = exchangeRate + 0;

    exchangeRate = _exchangeRate;
    feeAmount = MoneyTransferAmountHelper.roundSenderAmount(_fee, _senderCurrency);
    senderCurrency = _senderCurrency;
    receiverCurrency = _receiverCurrency;

    document.getElementById("senderAmount").dispatchEvent(new Event('change'));
    //updateReceivableAmount();
}

window.updateReceivableAmount = function (sentAmount) {

    updateReceivableAmountInternal(sentAmount);

    senderAmountExactElement.val(sentAmount);
}

window.updateReceivableAmountInternal = function (sentAmount) {
    var isTransferSummaryToUpdate = document.getElementById("updateTransferSummaryHeader") != null ||
        document.getElementById("transferSummaryHeader") != null;

    var sentAmountDec = new Decimal(0);

    if (sentAmount)
        sentAmountDec = new Decimal(NumberHelper.toInvariantCultureNumberString(sentAmount));

    var exchangeRateDec = new Decimal(exchangeRate);

    var receiverCurrency = jQuery("#receiverCurrency").val();
    var receivableAmountDec = MoneyTransferAmountHelper.roundReceiverAmount(exchangeRateDec.mul(sentAmountDec), receiverCurrency);
    var senderCurrency = jQuery("#senderCurrency").val();

    var isBelowLimit = IsSentAountBelowCountryLimit(window.banking.countryLimit, sentAmount);

    if(receiverCurrency === "VES" && receivableAmountDec <= VES_MAX_RECEIVER){
        continueButton.prop("disabled", false);
        senderAmountElement.css('color', 'black');
        receiverAmountElement.css('color', 'black');
        adviceReceiver.hide();
    }
    else if (receiverCurrency === "VES" && receivableAmountDec > VES_MAX_RECEIVER){
        continueButton.prop("disabled", true);
        senderAmountElement.css('color', 'red');
        adviceReceiver.fadeIn();

        // AB#1417: over the VES cap, clear the receiver field — same behavior as other countries
        // when they exceed their country limit (the generic `!isBelowLimit` branch below does
        // receiverAmountElement.val('')). This ALSO fixes the original bug: the field no longer
        // keeps a stale value (frozen while typing) nor the server prefill 0.000000 (on reload);
        // it is blanked and recomputed on every keystroke/reload.
        receiverAmountElement.val('');

        sentAmountDec = 0;
        receivableAmountDec = 0;
    }

    if (receivableAmountDec > 0 && isBelowLimit) {
        receiverAmountElement.val(receivableAmountDec);
        continueButton.prop("disabled", false);
        senderAmountElement.css('color', 'black');
        receiverAmountElement.css('color', 'black');
        advice.hide();

    } else if (receivableAmountDec > 0 && !isBelowLimit) {
        receiverAmountElement.val('');
        continueButton.prop("disabled", true);
        senderAmountElement.css('color', 'red');
        advice.fadeIn();

        sentAmountDec = 0;
        receivableAmountDec = 0;
    }
    else {
        continueButton.prop("disabled", true);
        senderAmountElement.css('color', 'black');

        sentAmountDec = 0;
        receivableAmountDec = 0;
    }

    if (isTransferSummaryToUpdate)
        updateTransferSummaryHeader(sentAmountDec, receivableAmountDec, senderCurrency, receiverCurrency, exchangeRate, feeAmount || transferFee);

    checkMinSentAmount(sentAmount);
}

window.updateSentAmount = function () {

    var isTransferSummaryToUpdate = document.getElementById("updateTransferSummaryHeader") != null ||
        document.getElementById("transferSummaryHeader") != null;

    var receivableAmountDec = new Decimal(0);

    if (receiverAmountElement.val())
        receivableAmountDec = new Decimal(NumberHelper.toInvariantCultureNumberString(receiverAmountElement.val()));

    var exchangeRateDec = new Decimal(exchangeRate);

    var sentAmountDec = receivableAmountDec.div(exchangeRateDec);

    var isBelowLimit = IsSentAountBelowCountryLimit(window.banking.countryLimit, sentAmountDec);

    var receiverCurrency = jQuery("#receiverCurrency").val();

    let senderAmount = '';
    if (sentAmountDec > 0 && receivableAmountDec > 0 && isBelowLimit) {
        senderAmount = MoneyTransferAmountHelper.roundSenderAmount(sentAmountDec, jQuery("#senderCurrency").val());
        senderAmountElement.val(senderAmount);

        continueButton.prop("disabled", false);
        senderAmountElement.css('color', 'black');
        receiverAmountElement.css('color', 'black');
        advice.hide();

        if (isTransferSummaryToUpdate)
            updateAmount(sentAmountDec, receivableAmountDec);
    } else if (sentAmountDec > 0 && receivableAmountDec > 0 && !isBelowLimit) {
        senderAmountElement.val(senderAmount);
        continueButton.prop("disabled", true);
        receiverAmountElement.css('color', 'red');
        advice.fadeIn();

        if (isTransferSummaryToUpdate)
            updateAmount(0, 0);
    } else {
        senderAmountElement.val(senderAmount);
        continueButton.prop("disabled", true);
        receiverAmountElement.css('color', 'black');

        if (isTransferSummaryToUpdate)
            updateAmount(0, 0);
    }

    if(receiverCurrency === "VES" && receivableAmountDec.toFixed(2) <= VES_MAX_RECEIVER){
        continueButton.prop("disabled", false);
        senderAmountElement.css('color', 'black');
        receiverAmountElement.css('color', 'black');
        adviceReceiver.hide();

        if (isTransferSummaryToUpdate)
            updateAmount(sentAmountDec, receivableAmountDec);
    }
    else if (receiverCurrency === "VES" && receivableAmountDec.toFixed(2) > VES_MAX_RECEIVER){
        continueButton.prop("disabled", true);
        receiverAmountElement.css('color', 'red');
        adviceReceiver.fadeIn();

        // AB#1417: over the VES cap, blank the sender field like other countries do when the
        // amount exceeds their country limit (the generic `!isBelowLimit` branch above does
        // senderAmountElement.val('')), instead of leaving the live value the generic valid
        // branch may have written. Field is never frozen; blanked/recomputed on every event.
        senderAmountElement.val('');

        if (isTransferSummaryToUpdate)
            updateAmount(0, 0);
    }

    checkMinSentAmount(sentAmountDec);

    senderAmountExactElement.val(sentAmountDec.toFixed(6));

    return senderAmount;
}

window.checkMinSentAmount = function (sentAmount) {

    tooLittleMoneyTxt.hide();
    if (sentAmount < window.banking.minTransferAmount && window.banking.minTransferAmount > -1) //-1 for disabled, like countrly limit
    {
        tooLittleMoneyTxt.show();
        continueButton.prop("disabled", true);
    }
}

window.IsSentAountBelowCountryLimit = function (countryLimit, sentAmount) {
    return countryLimit === -1 || sentAmount <= countryLimit
}

window.addEventListener('DOMContentLoaded', (event) => {
    jQuery('#amountForm').on("submit", function () {
        jQuery("#senderAmount").val(jQuery("#senderAmount").val().toFloat());
        return true;
    });
});